import { Directive, Input, Output, EventEmitter, ElementRef } from '@angular/core';

@Directive({
  selector: '[tlTimer]'
})
export class TimerDirective {

  /** 倒计时 单位 秒 */
  @Input('tlTimer') tlTimer: number = 0;
  @Output() tlTimerChange: EventEmitter<number> = new EventEmitter();

  constructor(
    private _elementRef: ElementRef,
  ) { }

  ngOnChanges(): void {
    if(this.tlTimer && !isNaN(this.tlTimer) && +this.tlTimer > 0){
      this._renderer();
    }
  }

  private _renderer = () => {
    const innerHTML: string = this._elementRef.nativeElement.innerHTML;
    const timer = setInterval(() => {
      if (this.tlTimer <= 0) {
        clearInterval(timer);
        this._elementRef.nativeElement.innerHTML = innerHTML;
        this.tlTimerChange.emit(0);
      } else {
        this.tlTimerChange.emit(this.tlTimer);
        this._elementRef.nativeElement.innerHTML = `${innerHTML} <span>(${this.tlTimer--})</span>`;
      }
    }, 1000);
  }

}